// libraries.
import { ModelError } from "@store/apiSlices/interfaces/interfaces";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiInventoryPortal } from "../../apiSlices";

// interfaces.
import { BonusInfoItem, BonusInfoParams } from "../interfaces/interfaces";

export const getBonusInfo = apiInventoryPortal.injectEndpoints({
  endpoints: (builder) => ({
    getBonusInfo: builder.query({
      providesTags: ["BonusInfo"],
      query: ({ country, nid }: BonusInfoParams) => {
        return `/bonus_info?country=${country}&nid=${nid}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getBonusInfo",
        };
        return modelError;
      },
      transformResponse: (response: BonusInfoItem) => {
        return response;
      },
    }),
  }),
});

export const { useGetBonusInfoQuery } = getBonusInfo;
